import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageRoma = props => {
  return <CityLandingPage cityKey="Roma" cityConfig={cityContent.roma} {...props} />;
};

export default LandingPageRoma;
